module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[6]127.49da80b.woff2";